import { render, staticRenderFns } from "./special-goods.vue?vue&type=template&id=d629eed8&scoped=true"
import script from "./special-goods.vue?vue&type=script&lang=ts"
export * from "./special-goods.vue?vue&type=script&lang=ts"
import style0 from "./special-goods.vue?vue&type=style&index=0&id=d629eed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d629eed8",
  null
  
)

export default component.exports